module.exports = __webpack_public_path__ + "img/img_default_shop_01.2b6dc76c.png";